export default __webpack_public_path__ + "static/media/Partner1.8387bbe2.png";